import withReadOnly from '../ReadOnlyAbilityWrapper';
import { Autocomplete } from './Autocomplete';
import { wrapInLabel } from '../NewInputLabelWrapper';
import withFormMeta from '../../FormMeta/withFormMeta';

const AutocompleteWithReadonly = withFormMeta(withReadOnly(wrapInLabel(Autocomplete)));

export default AutocompleteWithReadonly;
